export default __webpack_public_path__ + "static/media/princeton-university-logo.ff4c6b98.png";